"use strict";

exports.__esModule = true;
exports.getVisualMapOptions = void 0;
var getVisualMapOptions = exports.getVisualMapOptions = function getVisualMapOptions(toolbox, visualMap) {
  return {
    top: (toolbox == null ? void 0 : toolbox.orientation) === "vertical" ? 5 : 40,
    right: (toolbox == null ? void 0 : toolbox.orientation) === "vertical" ? 30 : 0,
    pieces: visualMap == null ? void 0 : visualMap.props,
    outOfRange: {
      color: visualMap == null ? void 0 : visualMap.defaultColor
    }
  };
};